import { useCallback, useEffect, useState } from 'react';

import { addGenericErrorToast } from 'core/notifications';
import { Sockets } from 'core/sockets';

export default ({ channelName, events = {}, options = { shouldAutoConnect: true } }) => {
  const { shouldAutoConnect } = options;
  const [isConnected, setIsConnected] = useState(false);

  const connect = useCallback(() => {
    if (!channelName || !Sockets.isConnected || Sockets.channels[channelName]) {
      return addGenericErrorToast();
    }

    Sockets.on(channelName, events);
    setIsConnected(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelName, events, Sockets.isConnected]);

  const disconnect = useCallback(() => {
    Sockets.off(channelName, events);
    setIsConnected(false);
  }, [channelName, events]);

  useEffect(() => {
    if (
      !channelName ||
      !shouldAutoConnect ||
      !Sockets.isConnected ||
      Sockets.channels[channelName]
    ) {
      return;
    }

    connect();

    return () => {
      disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelName, connect, disconnect, Sockets.isConnected, shouldAutoConnect]);

  return {
    connect,
    disconnect,
    isConnected,
  };
};
